<template>
	
	<section class="content-mt-more-list container-fluid col-xs-12">
		<div class="title text-center">
			<h2>{{title}}</h2>
			<p class="container">{{subtitle}}</p>
		</div>

		<div class="more-list container">
			<ul>
				<li v-for="index in moreList">
					 <a :href="index.elements.url.value">	{{ index.elements.header_title.value }} </a>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
	export default{
		name:'moreList',
		props:['moreList','title','subtitle']
	}
</script>


// WEBPACK FOOTER //
// more-list.vue?7508c9da